export default {
    routes: [
        // Unauthenticated portal routes (standalone, no AppLayout)
        {
            path: '/portal/:org',
            name: 'portal-login',
            component: () => import('@/pages/portal/Login.vue'),
            props: true
        },
        // Authenticated portal routes (AppLayout with sidebar)
        // Module-specific portal routes (accounting, projects, store, hosting, support)
        // are auto-discovered from modules/*/Resources/js/module.js via portalRoutes export.
        {
            path: '/portal/:org',
            component: () => import('@/pages/AppLayout.vue'),
            props: true,
            meta: { navType: 'portal' },
            children: [
                {
                    path: 'dashboard',
                    name: 'portal-dashboard',
                    component: () => import('@/pages/portal/Dashboard.vue')
                },

                // Profile
                { path: 'profile', name: 'portal-profile', component: () => import('@/pages/portal/Profile.vue') }
            ]
        }
    ],
    nav: null
};
